import { ErrorMessage } from '@hookform/error-message'
import { useFormContext } from 'react-hook-form'
import { useRef, useEffect, useState, Fragment, useContext } from 'react'
import { useTranslation } from 'next-i18next'
import PropTypes from 'prop-types'

// Internal components
import FormError from '../FormError/FormError'
import Svg from '../Svg/Svg'
import { UserContext } from '../../context/UserContext'

const revealClass = ' is-revealed'
const activeClass = ' is-active'

const FormItemRating = (props) => {
  const { item, onFormItemLoad, groupedState, revealState, onFormItemChange } = props

  const { register, watch, errors, formState, trigger } = useFormContext()
  const userContext = useContext(UserContext)

  // Translations
  const { t } = useTranslation(
    userContext?.userSession?.sportType?.slug ??
      process.env.NEXT_PUBLIC_RINUS_DEFAULT_NAMESPACE ??
      process.env.NEXT_PUBLIC_RINUS_DEFAULT_SPORT
  )
  const requiredErrorMessage = t('FORMITEM__ERROR_REQUIRED')

  // State
  const [isRequired, setIsRequired] = useState({ required: false })
  const [isGrouped, setIsGrouped] = useState(false)
  const [isLoaded, setIsLoaded] = useState(false)

  const itemRef = useRef()
  const itemProps = item
  const itemValue = watch(item.name)
  const itemInputRef = register(item.name, isRequired)

  useEffect(() => {
    if (!item.revealed && item.required) setIsRequired({ required: requiredErrorMessage })
  }, [])

  useEffect(() => {
    if (itemValue === undefined) return false
    if (!isLoaded) onFormItemLoad({ itemProps, itemRef, itemValue })
    else onFormItemChange({ itemProps, itemRef, itemValue })
    if (isLoaded) trigger()
    if (!isLoaded) setIsLoaded(true)
  }, [itemValue])

  useEffect(() => {
    if (!item.revealed || !item.required) return false
    setIsRequired({ required: revealState ? requiredErrorMessage : false })
    trigger()
  }, [revealState])

  useEffect(() => {
    if (item?.group && groupedState) {
      const itemLabel = item?.group?.label
      const groupedItem = groupedState.filter((str) => {
        return str.label.indexOf(itemLabel) >= 0
      })
      setIsGrouped(groupedItem[0].active)
    }
  }, [groupedState])

  const stars = []
  for (let i = 0; i < (item.value || 5); i++) {
    stars.push(i)
  }

  return (
    <div
      ref={itemRef}
      className={`FormItem FormItem--${item.type}${item.modifier ? ` FormItem--${item.modifier}` : ''}${
        revealState ? revealClass : ''
      }${!isGrouped ? '' : activeClass}`}
      data-reveal-target={item.revealed}
    >
      <div className="FormItem-rating">
        <div
          className={`FormItem-ratingList ${item.value ? 'FormItem-ratingList--output' : 'FormItem-ratingList--input'}`}
        >
          {stars.reverse().map((star) => {
            return (
              <Fragment key={`${item.name}_${star}`}>
                <input
                  type="radio"
                  id={`${item.name}_${star}`}
                  name={`${item.name}`}
                  value={parseInt(star) + 1}
                  className="FormItem-ratingRadioButton"
                  onChange={(e) => {
                    itemInputRef.onChange(e)
                  }}
                  ref={itemInputRef.ref}
                />
                <label className="FormItem-ratingLabel" htmlFor={`${item.name}_${star}`}>
                  <Svg id="icon-full-star" modifiers={['FormItem-ratingIcon']} />
                </label>
              </Fragment>
            )
          })}
        </div>
      </div>
      {formState.isSubmitted && <ErrorMessage errors={errors} name={item.name} as={<FormError />} />}
    </div>
  )
}

FormItemRating.propTypes = {
  item: PropTypes.object,
  onFormItemChange: PropTypes.func,
  onFormItemLoad: PropTypes.func,
  revealState: PropTypes.any,
  groupedState: PropTypes.any
}

export default FormItemRating
